module.exports = __webpack_public_path__ + "static/media/jobskills_bakgrundsbild_mobil.77f33334.jpg";